import React, { useCallback, useEffect, useState } from 'react'
import Grid from '@mui/material/Grid2';
import "./admin.css";
import "./rolesset.css";
import { faAngleRight, faChevronLeft, faChevronRight, faUserPlus, faFilter, faFilterCircleXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import AdminRoletabs from '../../components/common/AdminRoletabs';
import { Link, useNavigate } from 'react-router-dom';
import { faCircleDown } from '@fortawesome/free-regular-svg-icons';
import { apiService } from '../../services/apiService';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Select from 'react-select';
// import { useNavigate } from 'react-router-dom';
import { MenuItem, TextField } from '@mui/material';
import { saveAs } from 'file-saver';
import Papa from 'papaparse';
const profileImage = require('../../assets/defaultprofile.svg').default;
function UserMember() {
    const navigate = useNavigate();
    const [members, setMembers] = useState([]);
    const [loading, setLoading] = useState(true);
    const permissionstest = JSON.parse(localStorage.getItem('permissions'));

    const fetchMembers = useCallback(async () => {
        setLoading(true);
        try {
        const response = await apiService.getRequest('/admin/users');
        if(response.success === true){
            setMembers(response.data);
        }
        } catch (error) {
            console.error('Error fetching jobseeker status list:', error);
        }finally{
        setLoading(false);
        }
    }, []);
    useEffect(() => {
        fetchMembers();
    }, [fetchMembers]);
    const [isGridVisible, setGridVisible] = useState(false);
    const [currentPage, setCurrentPage] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [uniqueCityStatuses, setCitizenshipStatuses] = useState([]);
    // const handleShow = () => setShow(true);

    
    const toggleGrid = () => {
        setGridVisible((prev) => !prev);
    };

    const [filters, setFilters] = useState([{ operator: 'And', column: 'userName', operatorType: 'contains', value: '' }]);


    const combineOptions = [
        { value: 'And', label: 'And' },
        { value: 'Or', label: 'Or' },
    ];

    const rows = members.map((datas) => ({
        id: datas.id,
        format_id: datas.format_id,
        userName: datas.name,
        userImage: datas.profile || profileImage,
        group: datas.roles.map(role => role.display_name).join(', '),
        contactPhone: datas.phone_number,
        contactEmail: datas.email,
        suspended: datas.suspended,
        roles: datas.roles.map(role => ({
            display_name: role.display_name,
            color: role.color,
            bg_color: role.bg_color,
        }))
    }));

    const handleFilterChange = (index, field, value) => {
        const newFilters = [...filters];
        // Reset value if changing the column type
        if (field === 'column') {
            newFilters[index].value = newFilters[index].column === 'date' ? [null, null] : '';
        }
        newFilters[index][field] = value;
        setFilters(newFilters);
    };

    const addFilter = () => {
        setFilters([...filters, { operator: 'And', column: 'userName', operatorType: 'contains', value: '' }]);
    };

    const removeFilter = (index) => {
        setFilters(filters.filter((_, i) => i !== index));
    };
    useEffect(() => {
        const fetchData = async () => {
            const response = await apiService.getRequest('admin/roles-list');
            if (response.success) {
                setCitizenshipStatuses(response.data);
            }
        };
        fetchData();
    }, []);
    const operatorOptions = [
        { value: 'contains', label: 'contains' },
        { value: 'doesNotContain', label: 'does not contain' },
        { value: 'startsWith', label: 'starts with' },
        { value: 'endsWith', label: 'ends with' },
        { value: 'is', label: 'is' },
        { value: 'isNot', label: 'is not' },
        { value: 'isEmpty', label: 'is empty' },
        { value: 'isNotEmpty', label: 'is not empty' },
    ];
    const getOperatorOptions = (column) => {
        if (column === 'group') {
            return [
                { value: 'contains', label: 'contains' },
                { value: 'doesNotContain', label: 'does not contain' },
                { value: 'startsWith', label: 'starts with' },
                { value: 'endsWith', label: 'ends with' },
                { value: 'is', label: 'is' },
                { value: 'isNot', label: 'is not' },
                { value: 'isOneOf', label: 'is one of' },
                { value: 'isNotOneOf', label: 'is not one of' },
                { value: 'isEmpty', label: 'is empty' },
                { value: 'isNotEmpty', label: 'is not empty' },
            ];
        }
        return operatorOptions; // Default options
    };
    
    const filteredRows = rows.filter((row) =>
        filters.reduce((acc, filter, index) => {
            const rowValue = row[filter.column] ? row[filter.column].toString() : '';
            let matches = false;
    
            if (filter.column === 'group') {
                switch (filter.operatorType) {
                    case 'is':
                        matches = rowValue === filter.value;
                        break;
                    case 'isNot':
                        matches = rowValue !== filter.value;
                        break;
                    case 'contains':
                        matches = typeof filter.value === 'string' && rowValue.toLowerCase().includes(filter.value.toLowerCase());
                        break;
                    case 'doesNotContain':
                        matches = typeof filter.value === 'string' && !rowValue.toLowerCase().includes(filter.value.toLowerCase());
                        break;
                    case 'startsWith':
                        matches = typeof filter.value === 'string' && rowValue.toLowerCase().startsWith(filter.value.toLowerCase());
                        break;
                    case 'endsWith':
                        matches = typeof filter.value === 'string' && rowValue.toLowerCase().endsWith(filter.value.toLowerCase());
                        break;
                    case 'isEmpty':
                        matches = rowValue === '';
                        break;
                    case 'isNotEmpty':
                        matches = rowValue !== '';
                        break;
                    case 'isOneOf': // Check if at least one role matches
                        matches = Array.isArray(filter.value) && 
                            rowValue.split(', ').some(role => filter.value.includes(role));
                        break;
                    case 'isNotOneOf': // Ensure no roles match
                        matches = Array.isArray(filter.value) && 
                            !rowValue.split(', ').some(role => filter.value.includes(role));
                        break;
                    default:
                        matches = false;
                }
            } else {
                // General filter logic for other columns
                switch (filter.operatorType) {
                    case 'contains':
                        matches = rowValue.toLowerCase().includes(filter.value.toLowerCase());
                        break;
                    case 'doesNotContain':
                        matches = !rowValue.toLowerCase().includes(filter.value.toLowerCase());
                        break;
                    case 'startsWith':
                        matches = rowValue.toLowerCase().startsWith(filter.value.toLowerCase());
                        break;
                    case 'endsWith':
                        matches = rowValue.toLowerCase().endsWith(filter.value.toLowerCase());
                        break;
                    case 'is':
                        matches = rowValue === filter.value;
                        break;
                    case 'isNot':   
                        matches = rowValue !== filter.value;
                        break;
                    case 'isEmpty':
                        matches = rowValue === '';
                        break;
                    case 'isNotEmpty':
                        matches = rowValue !== '';
                        break;
                    default:
                        matches = false;
                }
            }
    
            return index === 0 ? matches : (filter.operator === 'And' ? acc && matches : acc || matches);
        }, true)
    );

    useEffect(() => {
        setCurrentPage(0);
    }, [filters]);
    const paginatedRows = filteredRows.slice(currentPage * pageSize, currentPage * pageSize + pageSize);

    const downloadCSV = () => {
        const csvData = filteredRows.map(row => ({  
            'ID': row.format_id,
            'Sub Admin': row.userName,
            'Email': row.contactEmail,
            'Phone Number': row.contactPhone,
            // 'Group': row.roles.map(role => role.display_name).join(', '),
        }));
        const csv = Papa.unparse(csvData); // Parse the data into CSV
        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
        saveAs(blob, 'filtered_jobseekers.csv'); // Trigger file download
    };
    const columns = [
        {
            field: 'format_id',
            headerName: 'ID',
            minWidth: 250,
            flex: 1,
            renderCell: (params) => (
                <div className='d-flex align-items-center h-100'>
                    {permissionstest && permissionstest.manage_subadmin_writer ? 
                    <Link to={`/user/member-edit/${params.row.id}`} className='cursetespoint' style={{color:"#C42B7D",textDecoration:"none"}} >{params.row.format_id}</Link>:
                    <span style={{color:"#C42B7D"}}>{params.row.format_id}</span>
                    }
                </div>
            ),
            filterable: true,
        },
        {
            field: 'userName',
            headerName: 'Sub Admin',
            minWidth: 350,
            flex: 1,
            renderCell: (params) => (
                <div className='d-flex align-items-center h-100'>
                    <Avatar src={params.row.userImage} alt={params.row.userName} />
                    <span className='ms-3'>{params.row.userName}</span>
                </div>
            ),
            filterable: true
        },
        
        {
            field: 'contactPhone',
            headerName: 'Phone',
            minWidth: 250,
            flex: 1,
            filterable: true,
            renderCell: (params) => (
                <Box className="linklistview h-100 d-flex align-items-center">
                    <Typography><span><a href={`tel:${params.row.contactPhone}`} target="_blank" rel="noopener noreferrer">{params.row.contactPhone}</a></span></Typography>
                </Box>
            ) 
        },
        {
            field: 'contactEmail',
            headerName: 'Email',
            minWidth: 300,
            flex: 1,
            filterable: true,
            renderCell: (params) => (
                <Box className="linklistview h-100 d-flex align-items-center">
                    <Typography><span><a href={`mailto:${params.row.contactEmail}`} target="_blank" rel="noopener noreferrer">{params.row.contactEmail}</a></span></Typography>
                </Box>
            )
        },
    ];




  return (
    <div className='container-fluid px-0'>
        <div className='content_container'>
            <Grid size={{xs:12}} container className="main_jobseeker">
                <Grid size={{xs:12}} container alignItems="center"> 
                    <Grid size={{md:8,xs:12}} container flexDirection="column" className="jobseekerhead">
                        <h3>User</h3>
                        <span><b onClick={()=>navigate("/dashboard")}>Dashboard</b> <FontAwesomeIcon className='angleright' icon={faAngleRight} /> User <FontAwesomeIcon className='angleright' icon={faAngleRight} /> Sub Admin</span>
                    </Grid>
                    <Grid size={{md:12,xs:12}} container justifyContent="space-between" alignItems="center" className="statusselectbtn my-4">
                        <Grid size={{sm:10,xs:12}} container>
                            <AdminRoletabs/>
                        </Grid>
                        <Grid container alignItems="center">
                            {permissionstest && permissionstest.manage_subadmin_writer ? 
                            <button className="small_adsbtn" onClick={()=>navigate("/user/member-add")}>
                                <FontAwesomeIcon icon={faUserPlus} />
                            </button>:""}
                        </Grid>
                    </Grid>  
                </Grid>
                {loading ? 
                    <div className='d-flex justify-content-center w-100'>
                        <img style={{ width: "100px" }} src={require('../../assets/pinkloader.gif')} alt='Loading...' />
                    </div> :<>
                    <Box sx={{ height: 650, width: '100%' }} className="datatable_jobpagi">
                        {isGridVisible && (
                        <Box sx={{ mb: 2 }} className="my-4">
                            {filters.map((filter, index) => (
                                <Box key={index} sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                    {index > 0 && (
                                        <select  
                                            label="Combine" 
                                            value={filter.operator}
                                            onChange={(e) => handleFilterChange(index, 'operator', e.target.value)}
                                            sx={{ mr: 1, minWidth: 80 }}
                                        >
                                            {combineOptions.map((option) => (
                                                <option key={option.value} value={option.value}>{option.label}</option>
                                            ))}
                                        </select>
                                    )}
                                    <TextField
                                        select  
                                        label="Column"
                                        value={filter.column}
                                        onChange={(e) => handleFilterChange(index, 'column', e.target.value)}
                                        sx={{ mr: 1, minWidth: 120 }}
                                    > 
                                        <MenuItem value="format_id">ID</MenuItem>
                                        <MenuItem value="userName">Sub Admin</MenuItem>
                                        <MenuItem value="contactEmail">Email</MenuItem>
                                        <MenuItem value="contactPhone">Phone Number</MenuItem>
                                    </TextField>
                                    <TextField
                                        select    
                                        label="Operator"
                                        value={filter.operatorType}
                                        onChange={(e) => handleFilterChange(index, 'operatorType', e.target.value)}
                                        sx={{ mr: 1, minWidth: 120 }}
                                    >
                                        {getOperatorOptions(filter.column).map((option) => (
                                            <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>
                                        ))}
                                    </TextField>
                                    {filter.operatorType === "isNotEmpty" || filter.operatorType === "isEmpty" ? "" :<>
                                        {filter.column === 'group' && !(filter.operatorType === "isNotOneOf" || filter.operatorType === "isOneOf") ? (
                                            <select 
                                                label="Value"
                                                value={filter.value}
                                                onChange={(e) => handleFilterChange(index, 'value', e.target.value)}
                                                sx={{ mr: 1, minWidth: 120 }}
                                            >
                                                <option value="" disabled>Select Group</option>
                                                {uniqueCityStatuses.map((status) => (
                                                <option key={status.id} value={status.name}>
                                                    {status.name}
                                                </option>
                                                ))}
                                            </select>
                                        ) : filter.column === 'group' && (filter.operatorType === "isNotOneOf" || filter.operatorType === "isOneOf")  ? (
                                            <Select
                                                isMulti
                                                className="basic-single select_withsearch"
                                                classNamePrefix="select"
                                                options={uniqueCityStatuses.map(status => ({
                                                    label: status.name,
                                                    value: status.name
                                                }))}
                                                value={Array.isArray(filter.value) ? filter.value.map(val => ({ label: val, value: val })) : []}
                                                onChange={(selectedOptions) => 
                                                    handleFilterChange(index, 'value', selectedOptions.map(option => option.value))
                                                }
                                                placeholder="Select Group"
                                                styles={{ container: (provided) => ({ ...provided, minWidth: 120, marginRight: '8px' }) }}
                                            />) : (
                                            <input
                                                className='value_inputfilter'
                                                placeholder='Value'
                                                label="Value"  
                                                value={filter.value}
                                                onChange={(e) => handleFilterChange(index, 'value', e.target.value)}
                                            />
                                        )}</>}
                                    <button className='filterremovebtn' onClick={() => removeFilter(index)}>Remove</button>
                                </Box>  
                            ))}
                            <button className='filteraddbtn' onClick={addFilter}>Add Filter</button>
                        </Box>)}
                        <Grid size={{xs:12}} container justifyContent="space-between">
                        <button className='show_filterbtn' onClick={toggleGrid}>
                            {isGridVisible ?<> Hide Filter <FontAwesomeIcon icon={faFilterCircleXmark} /> </> :<> Show Filter <FontAwesomeIcon icon={faFilter} /> </>}
                        </button>
                        <button className='download_csvbtndatatable' onClick={downloadCSV}>Download CSV<FontAwesomeIcon className='ps-2' icon={faCircleDown} /></button>
                        </Grid>
                        <DataGrid
                            style={{minHeight:"200px"}}
                            rows={paginatedRows}
                            columns={columns}  
                            pageSize={pageSize}  
                            disableSelectionOnClick
                            components={{ Toolbar: GridToolbar }}
                        />
                        <div className='d-flex flex-column my-3 pagination_datagrid'>
                            <Grid size={{xs:12}} container justifyContent="space-between">
                                <div className='d-flex justify-content-end align-items-center'>
                                    <label className='me-2'>Showing records <b>{filteredRows.length === 0 ? 0 : currentPage * pageSize + 1}–{Math.min((currentPage + 1) * pageSize, filteredRows.length)}</b> out of <b>{filteredRows.length.toLocaleString()}</b></label>
                                </div>
                                <div className='d-flex justify-content-end align-items-center'>
                                    <label>No. of Rows</label>
                                    <select
                                        label="Rows per page"
                                        value={pageSize}
                                        onChange={(e) => {setPageSize(Number(e.target.value)); setCurrentPage(0);}}
                                        sx={{ mr: 2 }}
                                    >
                                        {[5, 10, 20, 50].map((size) => (
                                            <option key={size} value={size}>{size}</option>
                                        ))}   
                                    </select>
                                </div>
                            </Grid>
                            <div className="d-flex justify-content-center my-3">
                                <button
                                    className='nexter_btns'
                                    variant="contained"
                                    onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 0))}
                                    disabled={currentPage === 0}
                                >
                                    <FontAwesomeIcon icon={faChevronLeft} />
                                </button>

                                {/* Page number buttons */}
                                {filteredRows.length > 0 && (
                                    <div className="d-flex align-items-center mx-2">
                                        {(() => {
                                        const totalPages = Math.max(1, Math.ceil(filteredRows.length / pageSize));
                                        const pages = [];

                                        const start = Math.max(1, currentPage + 1 - 2);
                                        const end = Math.min(totalPages - 1, currentPage + 1 + 2);

                                        // Always show first page
                                        pages.push(
                                            <button
                                            key={1}
                                            className={`page-btn ${currentPage === 0 ? 'active' : ''}`}
                                            onClick={() => setCurrentPage(0)}
                                            >
                                            1
                                            </button>
                                        );

                                        if (start > 2) {
                                            pages.push(<span key="start-ellipsis" className="px-1">...</span>);
                                        }

                                        for (let i = start; i <= end; i++) {
                                            if (i !== 1 && i !== totalPages) {
                                            pages.push(
                                                <button
                                                key={i}
                                                className={`page-btn ${currentPage === i - 1 ? 'active' : ''}`}
                                                onClick={() => setCurrentPage(i - 1)}
                                                >
                                                {i}
                                                </button>
                                            );
                                            }
                                        }

                                        if (end < totalPages - 1) {
                                            pages.push(<span key="end-ellipsis" className="px-1">...</span>);
                                        }

                                        if (totalPages > 1) {
                                            pages.push(
                                            <button
                                                key={totalPages}
                                                className={`page-btn ${currentPage === totalPages - 1 ? 'active' : ''}`}
                                                onClick={() => setCurrentPage(totalPages - 1)}
                                            >
                                                {totalPages}
                                            </button>
                                            );
                                        }

                                        return pages;
                                        })()}
                                    </div>
                                )}
 
                                <button  
                                    className='nexter_btns'
                                    variant="contained"
                                    onClick={() => setCurrentPage((prev) => Math.min(prev + 1, Math.ceil(filteredRows.length / pageSize) - 1))}
                                    disabled={currentPage >= Math.ceil(filteredRows.length / pageSize) - 1}
                                >
                                    <FontAwesomeIcon icon={faChevronRight} />
                                </button>
                            </div>
                        </div>
                    </Box>
                </>}
            </Grid>
        </div>
    </div>
  )
}

export default UserMember
